import React from 'react';

import { CaseOverviewTabContent } from '../case-overview-tab-content';

export const Case1OverviewTabContent = React.memo(() => {
  return (
    <CaseOverviewTabContent
      title={'Cognitive Diagnostics & Optimization'}
      description={
        'AI-based Cognitive Diagnostics & Optimization offers automated and self-learning solutions for network management and performance improvement, that assures full network visibility and high level of scalability, in a matter of minutes.'
      }
      assetType={'case1'}
    />
  );
});
